var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoBack1HIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8548 20.8415C13.8548 20.8415 15.6136 18.312 17.0424 16.8028C18.4712 15.2936 20.4457 14.36 22.6267 14.36C26.9869 14.36 30.5215 18.0909 30.5215 22.6933C30.5215 23.9463 30.2595 25.1347 29.7902 26.2008M13.8548 20.8415V15.2859M13.8548 20.8415H19.118",
    stroke: "#236795",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6198 26.6101V25.3381H18.8358V31.1781H17.4118V26.6101H16.6198ZM22.6516 26.6661C23.1636 26.6661 23.5742 26.8367 23.8836 27.1781C24.1929 27.5141 24.3476 27.9781 24.3476 28.5701V31.1781H22.9876V28.7541C22.9876 28.4554 22.9102 28.2234 22.7556 28.0581C22.6009 27.8927 22.3929 27.8101 22.1316 27.8101C21.8702 27.8101 21.6622 27.8927 21.5076 28.0581C21.3529 28.2234 21.2756 28.4554 21.2756 28.7541V31.1781H19.9076V25.2581H21.2756V27.3141C21.4142 27.1167 21.6036 26.9594 21.8436 26.8421C22.0836 26.7247 22.3529 26.6661 22.6516 26.6661Z",
    fill: "#3E3E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack1HIcon);
export default __webpack_public_path__ + "static/media/GoBack1hIcon.0fe49f82e9fe89626c398be1b8daaa1d.svg";
export { ForwardRef as ReactComponent };